// extracted by mini-css-extract-plugin
module.exports =  {"textarea":"_93444fe79c--textarea--p58Ff","counter":"_93444fe79c--counter--EYsRq"};